import AppButton from '@/components/atoms/AppButton';
import { EditFill } from '@/components/atoms/AppIcon';
import AppTable from '@/components/atoms/AppTable';
import { getServiceTypeLabel } from '@/constants/serviceType';
import type { RezeptSheet } from '@/types/admin-rezept-sheet';
import type { TableProps } from 'antd';
import type { SorterResult } from 'antd/es/table/interface';

interface RezeptSheetTableProps {
  data: RezeptSheet[];
  sortInfo?: { columnKey?: string; order?: 'ascend' | 'descend' };
  isLoading?: boolean;
  onTableChange?: (sorter: SorterResult<RezeptSheet> | SorterResult<RezeptSheet>[]) => void;
  onEditClick?: (id: number) => void;
}

const RezeptSheetTable = ({
  data,
  sortInfo,
  isLoading,
  onTableChange,
  onEditClick,
}: RezeptSheetTableProps) => {
  const getSortOrder = (key: string) => {
    return sortInfo?.columnKey === key ? sortInfo.order : undefined;
  };

  const columns: TableProps<RezeptSheet>['columns'] = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 90,
    },
    {
      title: '用紙名',
      dataIndex: 'sheet_name',
      key: 'sheet_name',
      sorter: true,
      sortOrder: getSortOrder('sheet_name'),
    },
    {
      title: 'サービス区分',
      dataIndex: 'service_type',
      key: 'service_type',
      width: 180,
      render: (_, record) => getServiceTypeLabel(record.service_type),
    },
    {
      title: '用紙枚数',
      dataIndex: 'unit_amount',
      key: 'unit_amount',
      width: 140,
      sorter: true,
      sortOrder: getSortOrder('unit_amount'),
    },
    {
      title: '用紙単価（税込）',
      dataIndex: 'price',
      key: 'price',
      width: 150,
      sorter: true,
      sortOrder: getSortOrder('price'),
    },
    {
      title: '並び順',
      dataIndex: 'sortno',
      key: 'sortno',
      width: 140,
      sorter: true,
      sortOrder: getSortOrder('sortno'),
    },
    {
      title: '操作',
      key: 'action',
      width: 120,
      render: (_, record) => (
        <AppButton
          icon={<EditFill />}
          type="primary"
          onClick={() => onEditClick?.(record.id)}
        >
          編集
        </AppButton>
      ),
    },
  ];

  return (
    <AppTable<RezeptSheet>
      columns={columns}
      dataSource={data}
      rowKey="id"
      loading={isLoading}
      onChange={(_, __, sorter) => onTableChange?.(sorter as SorterResult<RezeptSheet>)}
    />
  );
};

export default RezeptSheetTable;
